/*
 * View for a conversation variable
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "overlay",
  "./template/conversationVariablesModalTemplate.html",
  "modules/typeahead/typeaheadModel",
], function (
  Marionette,
  $,
  Messenger,
  Overlay,
  ConversationVariablesModalTemplate,
  TypeaheadModel,
) {
  var ConversationVariablesModalView = {};

  ConversationVariablesModalView.conversationVariablesModalView = Marionette.ItemView.extend({
    template: ConversationVariablesModalTemplate,
    modelEvents: {
      sync: "render",
    },
    onRender: function () {
      this.$el.i18n();
      //set up source function to get the typeahead data
      var _this = this;
      var sourceFunction = function (query, process) {
        var results = Messenger.reqres.request("substitutions:typeahead", query);
        results.once(
          "sync",
          function () {
            process(results.getResultsArray());
          },
          this,
        );
      };

      this.$el.find("#substitutionGroup").typeahead({
        source: sourceFunction,
        updater: function (item) {
          //set the value of the textbox
          _this.setSubGroupName(item);
          return item;
        },
      });

      this.setPatternOverlay();
    },
    getNameValue: function () {
      return this.$el.find("#variableName").val();
    },
    getDescriptionValue: function () {
      return this.$el.find("#description").val();
    },
    getValidationType: function () {
      return parseInt(this.$el.find("input[name=validationType]:checked").val());
    },
    getSubGroupName: function () {
      return this.$el.find("#substitutionGroup").val();
    },
    setSubGroupName: function (subGroupName) {
      this.$el.find("#substitutionGroup").val(subGroupName);
    },
    getPattern: function () {
      return this.$el.find("#patternValue").val();
    },
    setPattern: function (pattern) {
      this.$el.find("#patternValue").val(pattern);
    },
    insertPatternAtCarat: function (pattern) {
      var patternInput = this.$el.find("#patternValue");
      var caretPos = patternInput[0].selectionStart;
      var currentPattern = patternInput.val();
      patternInput.val(
        currentPattern.substring(0, caretPos) + pattern + currentPattern.substring(caretPos),
      );
      // This will keep the focus on the input text box at the same cursor position
      this.setCaretPosition(patternInput[0], caretPos + 3);
      // Make sure the overlay is added to the pattern placeholder
      this.setPatternOverlay();
    },
    setCaretPosition: function (elem, caretPos) {
      var range;
      if (elem.createTextRange) {
        range = elem.createTextRange();
        range.move("character", caretPos);
        range.select();
      } else {
        elem.focus();
        if (elem.selectionStart !== undefined) {
          elem.setSelectionRange(caretPos, caretPos);
        }
      }
    },
    setPatternOverlay: function () {
      var bracedPatterns = [];
      bracedPatterns.push("{a}");
      bracedPatterns.push("{d}");
      bracedPatterns.push("{u}");
      bracedPatterns.push("{l}");

      var patternOverlayStrategies = [
        {
          match: bracedPatterns,
          css: {
            "background-color": "rgba(0, 204, 0, 0.3)",
            "border-radius": "3px",
            "padding-bottom": "2px",
          },
        },
      ];

      this.$el.find("#patternValue").overlay(patternOverlayStrategies);
    },
    nameError: function (message) {
      this.$el
        .find("#variableNameError")
        .append('<h5 class="error-message">' + message + "<h5>")
        .hide()
        .fadeIn();
    },
    descriptionError: function (message) {
      this.$el
        .find("#descriptionError")
        .append('<h5 class="error-message">' + message + "<h5>")
        .hide()
        .fadeIn();
    },
    validationError: function (message) {
      this.$el
        .find("#validationError")
        .append('<h5 class="error-message">' + message + "<h5")
        .hide()
        .fadeIn();
    },
    clearErrors: function () {
      this.$el.find("h5.error-message").remove();
    },
    toggleSubGroupList: function (validationType) {
      var subGroupInput = this.$el.find("#substitutionGroup");
      var patternInput = this.$el.find("#patternValue");
      var patternButtonGroup = this.$el.find(".btn-validate-pattern button");
      if (validationType === 1) {
        subGroupInput.prop("disabled", false);
        patternInput.prop("disabled", true);
        patternButtonGroup.prop("disabled", true);
      } else if (validationType === 2) {
        patternInput.prop("disabled", false);
        subGroupInput.prop("disabled", true);
        patternButtonGroup.prop("disabled", false);
      } else {
        this.hideReusedPromptWarning();
        subGroupInput.prop("disabled", true);
        patternInput.prop("disabled", true);
        patternButtonGroup.prop("disabled", true);
      }
      //If validation is being re-added to the variable, show a message that the prompts are going to be reused.
      //We know it is being reused if it has an existing constraint Id.
      if (validationType > 0) {
        this.model.getValidationConstraints(function (constraints) {
          //check if the we are switching from no constraint
          if (constraints.get("constraintType") === 0) {
            //if there are existing invalid variable prompts, warn the user
            this.model.hasPrompts(
              this.model.INVALID_PROMPT_TYPE,
              function (hasPrompts) {
                if (hasPrompts) {
                  this.showReusedPromptWarning();
                }
              },
              this,
            );
          }
        }, this);
      }
    },
    showReusedPromptWarning: function () {
      this.$el
        .find("#promptReuseWarning")
        .html('<div class="alert">' + $.t("admin.conversationVariable.promptReuse") + "</div>");
    },
    hideReusedPromptWarning: function () {
      this.$el.find("#promptReuseWarning").html("");
    },
    events: {
      'change input[type="radio"][name="validationType"]': function () {
        this.toggleSubGroupList(this.getValidationType());
      },
    },
    triggers: {
      "click #addLetter": "add:letter:pattern",
      "click #addNumber": "add:number:pattern",
      "click #addUppercase": "add:uppercase:pattern",
      "click #addLowercase": "add:lowercase:pattern",
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return ConversationVariablesModalView;
});
